import {Command} from "commander";

module.exports = function (program: Command) {
    program
        .command('serve')
        .option('-p, --port <int>', 'From port, defaults to 8080', 8080)
        .option('--dev <bool>', 'Dev mode with watcher', false)
        .description('Serve the app')
        .action(async ({dev, port}) => {
            await require("../../server").default(port);
            await new Promise(r => {});
        });
}
